import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { OrderKindQuery, OrderKindQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(OrderKindQuery)
@Wrapper(OrderKindQueryHandlerBase)
export class OrderKindQueryHandler {
    public constructor(
        http: Http
    ) { }
}
